import React from 'react';

import GeneralRiskForm from './GeneralRiskForm';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function GeneralRiskUpsertModal(props) {
    const close = () => {
        props.onClose();
        props.modal.hide();
    };

    const onCreated = () => {
        close();
        props.onCreated();
    };

    const onDelete = () => {
        props.onDelete();
    };

    return (
        <Modal id={props.id} modal={props.modal} parentContainerClasses="modal__container-large">
            <ModalHeader title={props.risk ? $t('Edit {{name}}', { name: props.risk.description }) : $t('Add New Risk')} close={close}></ModalHeader>
            <div className="tw-rounded-b">
                {props.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div className="modal__form-container">
                        <GeneralRiskForm
                            allowVenueSelection={props.allowVenueSelection}
                            currentVenue={props.currentVenue}
                            datasets={props.datasets}
                            getPriorityUrl={props.getPriorityUrl}
                            storeUrl={props.storeUrl}
                            updateUrl={props.updateUrl}
                            fetchGeneralRiskBudgetLinesUrl={props.fetchGeneralRiskBudgetLinesUrl}
                            risk={props.risk}
                            budget_department_type={props.budget_department_type}
                            budget_department_id={props.budget_department_id}
                            onSuccess={onCreated}
                            onCancel={close}
                            includeRevenues={props.includeRevenues}
                            onDelete={onDelete}
                        />
                    </div>
                )}
            </div>
        </Modal>
    );
}
